/* DECOMURA: kolumna podglądu w mega menu i animacja wyjazdu.
   Kafle biorą się z mapy zapieczonej w motywie (`dcm-menu-top.js`), więc pokazują się natychmiast.
   Zmiana zawartości dopiero po zatrzymaniu kursora na innym odsyłaczu — inaczej kafle uciekałyby
   spod ręki, zanim zdążyłoby się w nie kliknąć. */
(function () {
  'use strict';
  if (window.DcmMenuMotion) return;
  var reduced = matchMedia('(prefers-reduced-motion:reduce)');
  var desktop = matchMedia('(min-width:990px)');
  var CZAS_ZATRZYMANIA = 500;
  var motions = new WeakMap();

  function cancel(details) {
    var trwajace = motions.get(details);
    if (trwajace) trwajace.forEach(function (animation) { animation.cancel(); });
    motions.delete(details);
  }
  function sync(details) {
    if (!details.open || !desktop.matches || reduced.matches) return;
    var content = details.querySelector('.mega-menu__content');
    if (!content) return;
    var body = content.querySelector('.dcm-menu-layout');
    cancel(details);
    var animacje = [content.animate(
      [
        { clipPath: 'inset(0 0 100% 0)', transform: 'translateY(-10px)', opacity: 0.35 },
        { clipPath: 'inset(0 0 0 0)', transform: 'translateY(0)', opacity: 1 },
      ],
      { duration: 340, easing: 'cubic-bezier(.22,.7,.25,1)' }
    )];
    if (body) animacje.push(body.animate(
      [{ transform: 'translateY(-10px)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }],
      { duration: 260, delay: 60, fill: 'backwards', easing: 'ease-out' }
    ));
    motions.set(details, animacje);
  }
  function open(details) {
    cancel(details);
    var content = details.querySelector('.mega-menu__content');
    if (content) content.inert = false;
    details.open = true;
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
    // Animacja startuje w tym samym kroku co otwarcie: zdarzenie `toggle` przychodzi dopiero
    // po odmalowaniu, więc czekanie na nie dawało jedną klatkę gotowego menu — czyli mignięcie.
    sync(details);
    pokazDomyslne(details);
  }
  function close(details) {
    if (!details.open) return;
    cancel(details);
    var content = details.querySelector('.mega-menu__content');
    content.inert = true;
    details.querySelector('summary').setAttribute('aria-expanded', 'false');
    function koniec() { details.open = false; content.inert = false; }
    if (reduced.matches || !desktop.matches) { koniec(); return; }
    var animacja = content.animate(
      [{ clipPath: 'inset(0 0 0 0)', opacity: 1 }, { clipPath: 'inset(0 0 100% 0)', opacity: 0 }],
      { duration: 190, easing: 'ease-in' }
    );
    motions.set(details, [animacja]);
    animacja.finished.then(function () {
      var biezaca = motions.get(details);
      if (biezaca && biezaca[0] === animacja) { motions.delete(details); koniec(); }
    }).catch(function () {});
  }
  window.DcmMenuMotion = { close: close, sync: sync };

  document.addEventListener('click', function (event) {
    var summary = event.target instanceof Element && event.target.closest('.header__inline-menu .mega-menu > summary');
    if (!summary || !desktop.matches) return;
    event.preventDefault();
    var details = summary.parentElement;
    if (details.open && !details.querySelector('.mega-menu__content').inert) close(details); else open(details);
  }, true);

  /* Otwieranie po najechaniu (jak w motywie Helix): krótkie opóźnienie zamiaru, zamknięcie
     dopiero po opuszczeniu całego menu z zapasem czasu na przejście do treści. */
  var zamiarOtwarcia = null, zamiarZamkniecia = null;
  document.addEventListener('pointerover', function (event) {
    if (!(event.target instanceof Element) || event.pointerType !== 'mouse' || !desktop.matches) return;
    var details = event.target.closest('.header__inline-menu .mega-menu');
    if (!details) return;
    clearTimeout(zamiarZamkniecia);
    if (details.open) return;
    var summary = event.target.closest('summary');
    if (!summary) return;
    clearTimeout(zamiarOtwarcia);
    zamiarOtwarcia = setTimeout(function () {
      if (!details.open && summary.matches(':hover')) open(details);
    }, 120);
  }, { passive: true });
  document.addEventListener('pointerout', function (event) {
    if (!(event.target instanceof Element) || event.pointerType !== 'mouse') return;
    var details = event.target.closest('.header__inline-menu .mega-menu');
    if (!details) return;
    var cel = event.relatedTarget;
    if (cel instanceof Node && details.contains(cel)) return;
    clearTimeout(zamiarOtwarcia);
    clearTimeout(zamiarZamkniecia);
    if (!details.open) return;
    zamiarZamkniecia = setTimeout(function () {
      if (details.open && !details.matches(':hover') && !details.contains(document.activeElement)) close(details);
    }, 280);
  }, { passive: true });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var details = event.target instanceof Element && event.target.closest('.header__inline-menu .mega-menu[open]');
    if (!details) return;
    event.preventDefault(); event.stopImmediatePropagation();
    close(details);
    details.querySelector('summary').focus();
  }, true);

  reduced.addEventListener('change', function () {
    document.querySelectorAll('.header__inline-menu .mega-menu').forEach(function (details) {
      cancel(details);
      var content = details.querySelector('.mega-menu__content');
      if (content && content.inert) { details.open = false; content.inert = false; }
    });
  });

  /* ---------- kafle ---------- */

  var pokazane = new WeakMap();
  var zegar = null;

  function uchwytKolekcji(link) {
    var m = /\/collections\/([^/?#]+)/.exec(link.getAttribute('href') || '');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function adresProduktu(uchwyt) {
    var korzen = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return korzen.replace(/\/$/, '/') + 'products/' + uchwyt;
  }
  function gotowy(img) {
    return new Promise(function (koniec) {
      if (img.complete && img.naturalWidth) return koniec();
      var czas = setTimeout(koniec, 4000);
      function ok() { clearTimeout(czas); koniec(); }
      img.addEventListener('load', ok, { once: true });
      img.addEventListener('error', ok, { once: true });
    });
  }
  var jezyk = (document.documentElement.lang || 'pl').slice(0, 2);
  function tytul(wzor, zapas) {
    var t = wzor.t || {};
    return t[jezyk] || t.pl || zapas || '';
  }
  // Nowe aranżacje AI (pole `a`, pion 3:4) mają pierwszeństwo przed starymi scenami (`i`). Od 21.10.2026 (decyzja
  // właściciela: „układ kafli: B”) kafle to dwa piony 3:4 obok siebie, więc zdjęcie AI idzie w całości (400/600 px).
  function wybierz(dane) {
    var zAI = dane.filter(function (w) { return w.a; });
    return zAI.concat(dane.filter(function (w) { return !w.a; })).slice(0, 2);
  }
  function obrazKafla(wzor) {
    if (!wzor.a) return { src: wzor.i, w: wzor.w, y: wzor.y };
    var u = new URL(wzor.a), maly = new URL(wzor.a);
    u.searchParams.set('width', '600');
    maly.searchParams.set('width', '400');
    return { src: u.href, srcset: maly.href + ' 400w, ' + u.href + ' 600w', w: wzor.aw || 1792, y: wzor.ay || 2400 };
  }
  // Podpis pod pionem: sama nazwa wzoru, bez dopisku po myślniku („SALT MARSH - tapeta z …” → „SALT MARSH”).
  function krotkaNazwa(nazwa) {
    return String(nazwa || '').split(/\s+[-–—]\s+/)[0].trim();
  }
  function zbuduj(panel, dane, etykieta) {
    var fragment = document.createDocumentFragment();
    wybierz(dane).forEach(function (wzor) {
      var nazwa = krotkaNazwa(tytul(wzor, etykieta));
      var a = document.createElement('a');
      a.className = 'dcm-menu-product';
      a.href = adresProduktu(wzor.h);
      var ramka = document.createElement('span');
      ramka.className = 'dcm-menu-product__frame';
      var img = document.createElement('img');
      var obraz = obrazKafla(wzor);
      img.src = obraz.src; // stara scena z mapy ma juz wariant 1200 px
      if (obraz.srcset) { img.srcset = obraz.srcset; img.sizes = '(min-width: 1440px) 260px, 220px'; }
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      img.loading = 'eager';
      img.fetchPriority = 'high';
      if (obraz.w && obraz.y) { img.width = obraz.w; img.height = obraz.y; }
      ramka.appendChild(img);
      var podpis = document.createElement('span');
      podpis.className = 'dcm-menu-product__name';
      podpis.textContent = nazwa;
      a.appendChild(ramka);
      a.appendChild(podpis);
      fragment.appendChild(a);
    });
    panel.replaceChildren(fragment);
    // Kolumna jest przezroczysta do chwili wczytania obu zdjęć: nigdy nie widać pustych ramek,
    // a miejsce jest zarezerwowane, więc menu nie drga.
    panel.dataset.loading = 'true';
    var obrazy = Array.prototype.slice.call(panel.querySelectorAll('img'));
    var znacznik = (panel.dataset.wersja = String(Number(panel.dataset.wersja || 0) + 1));
    Promise.all(obrazy.map(gotowy)).then(function () {
      if (panel.dataset.wersja === znacznik) delete panel.dataset.loading;
    });
  }
  function pokaz(link, takzeZamknięte) {
    var details = link.closest('.mega-menu');
    var panel = details && details.querySelector('[data-dcm-menu-preview]');
    if (!panel || !desktop.matches) return;
    if (!details.open && !takzeZamknięte) return;
    var uchwyt = uchwytKolekcji(link);
    if (!uchwyt) return;
    if (pokazane.get(panel) === uchwyt) return;
    var mapa = window.DcmMenuTop || {};
    var dane = mapa[uchwyt];
    if (!dane || !dane.length) return; // brak danych: zostaje to, co już widać
    pokazane.set(panel, uchwyt);
    zbuduj(panel, dane, (link.textContent || '').trim());
  }
  function pokazDomyslne(details, takzeZamknięte) {
    var panel = details.querySelector('[data-dcm-menu-preview]');
    if (!panel || pokazane.get(panel)) return;
    var pierwszy = details.querySelector('.dcm-menu-panel.is-active [data-dcm-menu-collection]') || details.querySelector('[data-dcm-menu-collection]');
    if (pierwszy) pokaz(pierwszy, takzeZamknięte);
  }

  /* ---------- zakładki grup (runda 7) ---------- */
  var zegarGrupy = null, ostatniX = null, kierunekWPrawo = false;
  function aktywujGrupe(btn, zrodlo) {
    var details = btn.closest('.mega-menu');
    if (!details || btn.classList.contains('is-active')) return;
    var nr = btn.dataset.dcmGroup;
    details.querySelectorAll('.dcm-menu-group[role="tab"]').forEach(function (b) {
      var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1;
    });
    details.querySelectorAll('.dcm-menu-panel').forEach(function (p) {
      var on = p.dataset.dcmPanel === nr; p.classList.toggle('is-active', on);
      if (on) { p.removeAttribute('inert'); p.removeAttribute('aria-hidden'); } else { p.setAttribute('inert', ''); p.setAttribute('aria-hidden', 'true'); }
    });
    var panel = details.querySelector('[data-dcm-menu-preview]');
    var link = details.querySelector('.dcm-menu-panel.is-active [data-dcm-menu-collection]');
    if (link && (zrodlo !== 'hover' || true)) { clearTimeout(zegar); if (panel) pokazane.delete(panel); pokaz(link, true); }
  }
  document.addEventListener('pointermove', function (event) {
    if (event.pointerType !== 'mouse') return;
    if (ostatniX !== null) kierunekWPrawo = event.clientX - ostatniX > 4;
    ostatniX = event.clientX;
  }, { passive: true });
  document.addEventListener('pointerover', function (event) {
    if (!(event.target instanceof Element) || event.pointerType !== 'mouse' || !desktop.matches) return;
    var btn = event.target.closest('.dcm-menu-group[role="tab"]');
    if (!btn) return;
    clearTimeout(zegarGrupy);
    // Ruch w prawo (w stronę odsyłaczy) nie powinien przełączać grupy po drodze — dłuższy zamiar.
    zegarGrupy = setTimeout(function () { if (btn.matches(':hover')) aktywujGrupe(btn, 'hover'); }, kierunekWPrawo ? 260 : 90);
  }, { passive: true });
  document.addEventListener('pointerout', function (event) {
    if (event.target instanceof Element && event.target.closest('.dcm-menu-group[role="tab"]')) clearTimeout(zegarGrupy);
  }, { passive: true });
  document.addEventListener('click', function (event) {
    var btn = event.target instanceof Element && event.target.closest('.dcm-menu-group[role="tab"]');
    if (btn) aktywujGrupe(btn, 'click');
  });
  document.addEventListener('focusin', function (event) {
    var btn = event.target instanceof Element && event.target.closest('.dcm-menu-group[role="tab"]');
    if (btn) aktywujGrupe(btn, 'focus');
  });
  document.addEventListener('keydown', function (event) {
    var btn = event.target instanceof Element && event.target.closest('.dcm-menu-group[role="tab"]');
    if (!btn) return;
    var lista = Array.prototype.slice.call(btn.closest('[role="tablist"]').querySelectorAll('.dcm-menu-group[role="tab"]'));
    var i = lista.indexOf(btn), cel = null;
    if (event.key === 'ArrowDown') cel = lista[(i + 1) % lista.length];
    else if (event.key === 'ArrowUp') cel = lista[(i - 1 + lista.length) % lista.length];
    else if (event.key === 'Home') cel = lista[0];
    else if (event.key === 'End') cel = lista[lista.length - 1];
    if (cel) { event.preventDefault(); cel.focus(); }
  });

  // Najechanie na sam napis menu zaczyna wczytywanie kafli, więc po kliknięciu są już gotowe.
  document.addEventListener('pointerover', function (event) {
    if (!(event.target instanceof Element) || event.pointerType !== 'mouse' || !desktop.matches) return;
    var summary = event.target.closest('.header__inline-menu .mega-menu > summary');
    if (summary) pokazDomyslne(summary.parentElement, true);
  }, { passive: true });

  document.addEventListener('pointerover', function (event) {
    if (!(event.target instanceof Element) || event.pointerType !== 'mouse' || !desktop.matches) return;
    // Kursor nad samymi kaflami nigdy ich nie podmienia.
    if (event.target.closest('[data-dcm-menu-preview]')) { clearTimeout(zegar); return; }
    var link = event.target.closest('[data-dcm-menu-collection]');
    if (!link) return;
    clearTimeout(zegar);
    zegar = setTimeout(function () { pokaz(link); }, CZAS_ZATRZYMANIA);
  }, { passive: true });

  document.addEventListener('focusin', function (event) {
    var link = event.target instanceof Element && event.target.closest('[data-dcm-menu-collection]');
    if (link) { clearTimeout(zegar); pokaz(link); }
  });

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!(details instanceof Element) || !details.matches('.header__inline-menu .mega-menu')) return;
    if (details.open) {
      if (!motions.get(details)) sync(details); // otwarcie spoza naszego kliknięcia (np. klawiatura)
      pokazDomyslne(details);
      return;
    }
    clearTimeout(zegar);
    var panel = details.querySelector('[data-dcm-menu-preview]');
    if (panel) pokazane.delete(panel);
  }, true);
})();
